module.exports = __webpack_public_path__ + "img/follow_btn_saved.5a3c7863.svg";